import { IFilterSet, SelectedFilters } from "../types";

export function buildFilterParams(
  selectedFilters: SelectedFilters,
  filterSets: IFilterSet[],
): Record<string, string> {
  const params: Record<string, string> = {};

  for (const [title, values] of Object.entries(selectedFilters)) {
    if (!values || values.length === 0) continue;

    const filterSet = filterSets.find((f) => f.title === title);
    if (!filterSet) continue;

    switch (filterSet.type) {
      case "multiple_choice":
        params[filterSet.param] = values.join(",");
        break;

      case "boolean_choice":
        params[filterSet.param] = "true";
        break;

      case "single_choice": {
        const isRange = filterSet.filterItems.some(
          (item) => item.id === "min" || item.id === "max",
        );
        if (isRange && values.length === 2) {
          if (filterSet.param === "price_range") {
            params[filterSet.param] = `$${values[0]}+-+$${values[1]}`;
          } else {
            params[filterSet.param] = `${values[0]}+-+${values[1]}`;
          }
        } else {
          params[filterSet.param] = values.join(",");
        }
        break;
      }
    }
  }

  return params;
}
